export default class DateService {
  public static getDaysUntil(untilDate: string): number {
    const futureDate = new Date(untilDate);
    const currentDate = new Date();
    const timeDifference = futureDate.getTime() - currentDate.getTime();
    return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  }
}
